module.exports = __webpack_public_path__ + "static/Whole Sol Nutrition Facts (1).1e0a6a77.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/Whole Sol Nutrition Facts (1).pdf
// module id = 683
// module chunks = 79611799117203